/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DistritoIdDistrictGet$Params {
  idDistrict: string;
}

export function distritoIdDistrictGet(http: HttpClient, rootUrl: string, params: DistritoIdDistrictGet$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, distritoIdDistrictGet.PATH, 'get');
  if (params) {
    rb.path('idDistrict', params.idDistrict, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<any>;
    })
  );
}

distritoIdDistrictGet.PATH = '/distrito/{idDistrict}';
